const formatToFormData = (formData, key, data) => {
    if (data instanceof Array) {
        for (let i = 0; i < data.length; i += 1) {
            if (data instanceof Array || data instanceof Object) {
                formatToFormData(formData, `${key}[${i}]`, data[i]);
            }
        }
    } else if (data instanceof Object && !(data instanceof File) && !(data instanceof Image) && !(data instanceof Blob)) {
        for (const prop in data) {
            if (data instanceof Array || data instanceof Object) {
                formatToFormData(formData, `${key}[${prop}]`, data[prop]);
            }
        }
    } else {
        console.log(key.trim(), data)
        formData.append(key, data);
    }
}

export const changeBodyToForm = (body) => {
    const formData = new FormData();
    Object.keys(body).forEach((key) => {
        formatToFormData(formData, key, body[key]);
    });
    return formData;
}